import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Form, Input, InputNumber, Popconfirm, Select, Space, Table, Typography } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import AppContext from '../../../../AppContext';
import { getBankingStandardsByCountry, deleteBankingStandards, getValidations, saveBankingStandards, saveValidation, deleteValidation } from '../../../../networking/NetworkingCountries';
import { getCurrencies } from '../../../../networking/NetworkingCurrencies';
import { getCountries } from '../../../../networking/NetworkingCountries';
import AlertBox from '../../../shared/AlertBox';
import { getStyle } from '../../../../styles/styles';

var style = getStyle();
const { Option } = Select;

const NewValidatioinsScreen = () => {   
    const context = useContext(AppContext);    
    const [form] = Form.useForm();
    const searchInput = useRef();
    const [showAlert, setShowAlert] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [updating, setUpdating] = useState(false);
    const [searchedColumn, setSearchedColumn] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState(''); 
    const [editingKey, setEditingKey] = useState(0);
    const [currentPage, setCurrentPage] = useState();
    const [currentValidationID, setCurrentValidationID] = useState(0);
    const [validations, setValidations] = useState([]);
    const [searchArray, setSearchArray]                 = useState({});
    
    useEffect(() => {
        context.startLoading();
        loadValidations();
        context.finishLoading();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    useEffect(() => {
        loadValidations();
    }, [updating]);

    //#region
    const loadValidations = async () => {
        const json = await getValidations();
        if (json != null && json.data != null) {
            let validations = json.data;
            setValidations(validations);
        }
    };

    const cancel = (page, pageSize) => {
        setEditingKey(0);
        if (typeof page === 'number') {
            setCurrentPage(page);
        }
        if (validations[0]['Id'] === 0) {
            let auxStates = [...validations];
            auxStates.shift();
            setValidations(auxStates);
        }
        setCurrentValidationID(0);
    };
    
    const isEditing = (record) => record['Id'] === editingKey;

    function itemRender(current, type, originalElement) {
        if (type === 'prev') {
          return <a>Previous</a>;
        }
        if (type === 'next') {
          return <a>Next</a>;
        }
        return originalElement;
    };

    const closeAlert = () => {
        setShowAlert(false);
    };
    
    const handleSearch = (selectedKeys, confirm, dataIndex) => {         
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    
    const handleReset = clearFilters => {        
        clearFilters();
        setSearchText('');
    };
    
    const settingSearchStateValues = (value, col) => {
        setSearchText(value);
        setSearchedColumn(col);
        setSearchArray(...searchArray[col] = value);
    };

    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
            <Input
                ref           = {node => {searchInput.current = node;}}
                placeholder   = {`Search ${dataIndex}`}
                value         = {selectedKeys[0]}
                onChange      = {(e) => {
                    setSelectedKeys(e.target.value ? [e.target.value] : [])}
                }
                onPressEnter  = {() => handleSearch(selectedKeys, confirm, dataIndex)}
                style         = {{
                    width       : 188, 
                    marginBottom: 8, 
                    display     : 'block' 
                }}
            />
            <Space>
                <Button
                    type    = "primary"
                    onClick = {() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon    = {<SearchOutlined />}
                    size    = "small"
                    style   = {{ width: 90 }}
                >Search
                </Button>
                <Button 
                    onClick = {() => {
                        handleReset(clearFilters);
                    }}
                    size    = "small" 
                    style   = {{ width: 90 }}
                >Reset
                </Button>
                {/*<Button
                    type    = "link"
                    size    = "small"
                    onClick = {() => {
                        confirm({ closeDropdown: false });
                        settingSearchStateValues(selectedKeys[0], dataIndex);
                    }}
                >Filter
                </Button>*/}
            </Space>
          </div>
        ),
        filterIcon                      : filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter                        : (value, record) =>
          record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
        onFilterDropdownVisibleChange   : visible => {
          if (visible) {
            setTimeout(() => searchInput.current.select(), 100);
          }
        },
        render                          : text => searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle    = {{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords       = {[searchText]}
              autoEscape
              textToHighlight   = {text ? text.toString() : ''}
            />
          ) : (
            text
          )
    });

    const save = async (record) => {
        try {
            const row = await form.validateFields();
            const newData = [...validations];
            const index = newData.findIndex((item) => record === item['Id']);
            if (index > -1) {
                //const userID = localStorage.getItem('UserID');
                const model = {
                    Id: validations[index]['Id'] !== 0 ? currentValidationID : 0,
                    Name: row['Name'],
                    Description: row['Description'],
                    Regex: row['Regex'],
                    ValidationMessage: row['ValidationMessage']
                };
                context.startLoading();
                const json = await saveValidation(model);
                context.finishLoading();
                if (json != null) {
                    if (json.httpStatusCode !== 200) {
                        setShowAlert(true);
                        setAlertTitle('Error');
                        setAlertMessage(json.httpErrorMessage);
                        setUpdating(!updating);
                        setEditingKey(0);
                    } else {
                        setShowAlert(true);
                        setAlertTitle('Success');
                        setAlertMessage('Validation successfully saved.');
                        setUpdating(!updating);
                        setEditingKey(0);
                        setCurrentValidationID(0);
                    }
                }
            }
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    }

    const edit = (record) => {
        if (validations[0]['Id'] === 0) {
            let auxStates = [...validations];
            auxStates.shift();
            setValidations(auxStates);
        }
        form.setFieldsValue({
            UpdateToken: '',
            ...record
        });
        setEditingKey(record['Id']);
        setCurrentValidationID(record['Id']);
    }

    const deleteRecord = async (record) => {
        context.startLoading();
        const deleteResponse = await deleteValidation(record['Id']);
        context.finishLoading();
        if (deleteResponse != null) {
            if (deleteResponse.httpStatusCode !== 200) {
                setShowAlert(true);
                setAlertTitle('Error');
                setAlertMessage(deleteResponse.httpErrorMessage);
                setUpdating(!updating);
            } else {
                setShowAlert(true);
                setAlertTitle('Success');
                setAlertMessage('Validation successfully removed.');
                setUpdating(!updating);
            }
        }
    }

    const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
        let inputNode = null;
        switch (inputType) 
        {
            case 'number':
            {
                inputNode = <InputNumber style={{ width: '100%', textAlignLast: 'center'}}/>;
                break;
            }
            default:
            {
                inputNode = <Input style={{textAlign: 'center'}}/>;
                break;
            }
        }
        let styleEdit = {margin: 0};

        if((record !== undefined && record.isNew !== undefined && record.isNew === true) || editing)
        {
            styleEdit = {
                paddingBottom   : 10, 
                paddingTop      : 10,
                margin          : 0,
            }
        }
        let isRequired = true;
        /*if(title==='Regex' || title==='ValidationMessage'){
            isRequired=false;
        }*/
        return (
            <td {...restProps}>
              {editing ? (
                <Form.Item
                  name={dataIndex}
                  style={styleEdit}
                  rules={[
                    {
                      required: isRequired,
                      message : `Please Input ${title}!`,
                    },
                  ]}
                >
                  {inputNode}
                </Form.Item>
              ) : (
                children
              )}
            </td>
          );
    };

    const columns = [
        {
            title           : 'Name',
            dataIndex       : 'Name',
            width           : '10%',
            editable        : true,
            align           : 'center',
            defaultSortOrder: 'ascend',
            sorter          : (a, b) => { return a.Name.localeCompare(b.Name)},
            sortDirections  : ['descend', 'ascend'],
            filterMultiple  : false,
            onFilter        : (value, record) => {  
                if(record.Name.indexOf(value) === 0)
                {
                    return true;
                }
            },
            ...getColumnSearchProps('Name'),
        },
        {
            title           : 'Description',
            dataIndex       : 'Description',
            width           : '10%',
            editable        : true,
            align           : 'center',
            defaultSortOrder: 'ascend',
            sorter          : (a, b) => { return a.Description.localeCompare(b.Description)},
            sortDirections  : ['descend', 'ascend'],
            filterMultiple  : false,
            onFilter        : (value, record) => {  
                if(record.Description.indexOf(value) === 0)
                {
                    return true;
                }
            },
            ...getColumnSearchProps('Description'),
        },
        {
            title           : 'Regex',
            dataIndex       : 'Regex',
            width           : '10%',
            editable        : true,
            align           : 'center',
            defaultSortOrder: 'ascend',
            sorter          : (a, b) => { return a.Regex.localeCompare(b.Regex)},
            sortDirections  : ['descend', 'ascend'],
            filterMultiple  : false,
            onFilter        : (value, record) => {  
                if(record.Regex.indexOf(value) === 0)
                {
                    return true;
                }
            },
            ...getColumnSearchProps('Regex'),
        },
        {
            title           : 'ValidationMessage',
            dataIndex       : 'ValidationMessage',
            width           : '10%',
            editable        : true,
            align           : 'center',
            defaultSortOrder: 'ascend',
            sorter          : (a, b) => { return a.ValidationMessage.localeCompare(b.ValidationMessage)},
            sortDirections  : ['descend', 'ascend'],
            filterMultiple  : false,
            onFilter        : (value, record) => {  
                if(record.ValidationMessage.indexOf(value) === 0)
                {
                    return true;
                }
            },
            ...getColumnSearchProps('ValidationMessage'),
        },
        {
            title: 'Actions',
            dataIndex: 'Actions',
            align: 'center',
            width: '15%',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                <span>
                    <a
                        onClick = {() => save(record.Id)}
                        style   = {{
                            marginRight: 8,
                        }}
                    >Save</a>
                    <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                        <a>Cancel</a>
                    </Popconfirm>
                </span>
                ) : (
                <div>
                    <Space size="middle">                        
                        <Typography.Link disabled={editingKey !== 0 ? true: (validations[0]['Id'] === 0) ? true: false} onClick={() => edit(record)}>
                            Edit
                        </Typography.Link>
                        <Popconfirm title = "Sure to delete?" onConfirm = {() => {deleteRecord(record)}}>
                            <a disabled = {editingKey !== 0 ? true: (validations[0]['Id'] === 0) ? true: false} >Delete</a>
                        </Popconfirm>
                    </Space>
                </div>
                );
            },
        }
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        let type = '';
        switch (col.dataIndex) {
            case 'Label': {
                type = 'select-label';
                break;
            }
            default: {
                type = 'text';
                break;
            }
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: type,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record)
            })
        };
    });

    const addNewValidation = () => {
        let actual = [...validations];
        if (actual[0] != null && actual[0]['Id'] === 0) {
            return;
        } else {
            actual.unshift({
                'Id': 0,
                'Name': '',
                'Description': '',
                'Regex': '',
                'ValidationMessage': '',
                isNew: true
            });
            setValidations(actual);
            setCurrentPage(1);
            form.setFieldsValue({
                'Name': '',
                'Description': '',
                'Regex': '',
                'ValidationMessage': '',
                ...actual
            });
            setCurrentValidationID(0);
        }
    }
    //#endregion

    return(
        <div>
            <h5 className="uk-accordion-title">Validations</h5>
            <Form form={form} component={false}>                
                <Table
                    components      = {{ body: { cell: EditableCell } }}
                    //bordered        = {true}
                    dataSource      = { validations }
                    columns         = { mergedColumns }
                    //rowClassName    = "editable-row"
                    pagination      = {{
                        onChange        : cancel,
                        showQuickJumper : true,
                        itemRender      : itemRender,
                        current         : currentPage,
                        defaultCurrent  : 1,
                        size            : 'default'
                    }}
                    size            = 'small'
                    footer          = {() => {
                        return(
                            <Button 
                                type        = "dashed" 
                                onClick     = {addNewValidation}
                                block
                                icon        = {<PlusOutlined />}
                                style       = {{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                                disabled    = {editingKey !== 0 || (validations[0] !== undefined && validations[0]['Id'] === 0)}
                            >Add a Validation
                            </Button>
                        );
                    }}
                />
            </Form>
            
            <AlertBox id="alert-new-bankingStandard" open={showAlert} onClose={closeAlert} title={alertTitle} message={alertMessage} type="Ok" okClick={closeAlert} />
        </div>
    );

};

export default NewValidatioinsScreen;